import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'brt-user-avatar',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.css'
})
export class UserAvatarComponent {
  @Input({required: true}) userId: string;
  @Input({required: true}) profile: any;
  @Input({required: true}) identity: any;
}
